import React from "react";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from "./cardcarousel.module.css"

const cards = [

  {
    id: 1,
    img: 'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/استخر-اسفنج-(1)(2).jpg',
    title: "استخر اسفنج"
  },
  {
    id: 2,
    img: 'https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/بسکتبال-(1)(2).jpg',
    title: "بسکتبال"
  },
  {
    id: 3,
    img: "https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/بیلیارد.jpg",
    title: "فوتیارد"
  },
  {
    id: 4,
    img: "https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/ترامپولین-(2).jpg",
    title: "ترامپولین"
  },
  {
    id: 5,
    img: "https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/ترامپولین-حرفه-ای.jpg",
    title: "ترامپولین حرفه‌ای"
  },
  {
    id: 6,
    img: "https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/داج-بال-(1)(2).jpg",
    title: "داج بال"
  },
  {
    id: 7,
    img: "https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/دیوار-شیب-دار-(1).jpg",
    title: "دیوار شیب‌دار"
  },
  {
    id: 8,
    img: "https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/صخره-نوردی.jpg",
    title: "صخره‌نوردی"
  },
  {
    id: 9,
    img: "https://s5.uupload.ir/files/mhvpcr/عکس بازی هلیوم پارک/فوتبال-حبابی-(1).jpg",
    title: " فوتبال حبابی"
  },

]

const Cardcarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive : [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  return (
    <div className={styles.carouselContain}>
      <Slider {...settings}>
        {cards.map((card) => (
          <a className={styles.cardHref} href="/Games">
            <div className={styles.card} key={card.id}>
              <img className={styles.gameimg} src={card.img} alt="gameimg" />
              <h3 className={styles.gameTitle}>{card.title}</h3>
            </div>
          </a>
        ))}
      </Slider>
    </div>
  );
}
export default Cardcarousel;